"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupLogger = void 0;
const loglevel_1 = __importDefault(require("loglevel"));
const chalk_1 = __importDefault(require("chalk"));
const loglevel_plugin_prefix_1 = __importDefault(require("loglevel-plugin-prefix"));
loglevel_plugin_prefix_1.default.reg(loglevel_1.default);
const _logger = loglevel_1.default.getLogger('lib-commons');
global.logger = _logger;
const colors = {
    SILENT: chalk_1.default.magenta,
    TRACE: chalk_1.default.magenta,
    DEBUG: chalk_1.default.cyan,
    INFO: chalk_1.default.blue,
    WARN: chalk_1.default.yellow,
    ERROR: chalk_1.default.red,
};
_logger.setDefaultLevel('INFO');
loglevel_plugin_prefix_1.default.apply(_logger, {
    format(level, name, timestamp) {
        const ch = colors[level.toUpperCase()] || colors['TRACE'];
        return `${chalk_1.default.gray(`[${timestamp}]`)} ${ch(level)} ${chalk_1.default.green(`${name}:`)}`;
    },
});
loglevel_plugin_prefix_1.default.apply(_logger, {
    format(level, name, timestamp) {
        return chalk_1.default.red.bold(`[${timestamp}] ${level} ${name}:`);
    },
});
const defaultOptions = {
    level: 'INFO',
};
const setupLogger = (options) => {
    const opt = { ...defaultOptions, ...options };
    _logger.setLevel(opt.level);
    return _logger;
};
exports.setupLogger = setupLogger;
